module.exports = __webpack_public_path__ + "img/task-page.c0c27909.png";